// // import React, { useEffect, useRef, useState } from "react";
// // import { Link } from "react-router-dom";
// // import Navbar from "../components/Navbar";
// // import HlcFooter from "../components/HlcFooter";
// // import ceo from "../assets/ceo.jpeg";
// // import { db } from "../firebase";
// // import { ref as dbRef, onValue } from "firebase/database";

// // export default function AboutUsPage() {
// //   const animatedRefs = useRef([]);
// //   const [certificates, setCertificates] = useState([]);

// //   // Fetch certificates from Firebase
// //   useEffect(() => {
// //     const certRef = dbRef(db, "certificates");
// //     onValue(certRef, (snapshot) => {
// //       const data = snapshot.val();
// //       if (data) {
// //         setCertificates(Object.entries(data).map(([id, value]) => ({ id, ...value })));
// //       } else {
// //         setCertificates([]);
// //       }
// //     });
// //   }, []);

// //   useEffect(() => {
// //     const elements = animatedRefs.current.filter(Boolean);
// //     if (!elements.length) return;

// //     const observer = new IntersectionObserver(
// //       (entries) => {
// //         entries.forEach((entry) => {
// //           if (entry.isIntersecting) {
// //             entry.target.classList.add("show");
// //             observer.unobserve(entry.target);
// //           }
// //         });
// //       },
// //       { threshold: 0.15 }
// //     );

// //     elements.forEach((el) => observer.observe(el));

// //     return () => observer.disconnect();
// //   }, []);

// //   const addToRefs = (el) => {
// //     if (el && !animatedRefs.current.includes(el)) {
// //       animatedRefs.current.push(el);
// //     }
// //   };

// //   // Duplicate cards for infinite loop effect (need at least 2 sets)
// //   const sliderCards = certificates.length > 0
// //     ? [...certificates, ...certificates]
// //     : [];

// //   return (
// //     <>
// //       <Navbar />
// //       <style>{`
// //         :root{
// //           --about-magenta:#9b1f6c;
// //           --about-plum:#542757;
// //           --about-navy:#35335b;
// //           --about-text:#141320;
// //           --about-muted:#6b677a;
// //           --about-line:#eceaf1;
// //           --about-bg:#f7f7fb;
// //           --about-white:#ffffff;
// //           --about-light:rgba(255,255,255,.88);
// //           --about-soft:rgba(255,255,255,.74);
// //           --about-line-white:rgba(255,255,255,.14);
// //         }

// //         .about-page-root{
// //           width:100%;
// //           overflow:hidden;
// //           font-family:"Open Sans",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
// //           background:#fff;
// //            margin-top:40px

// //         }

// //         /* =========================================================
// //            SHARED ANIMATION
// //         ========================================================= */
// //         .about-animate-up,
// //         .about-reveal{
// //           opacity:0;
// //           transform:translateY(40px);
// //           transition:opacity .8s ease, transform .8s ease;
// //         }

// //         .about-animate-up.show,
// //         .about-reveal.show{
// //           opacity:1;
// //           transform:none;
// //         }

// //         .about-delay-1{ transition-delay:.15s; }
// //         .about-delay-2{ transition-delay:.3s; }

// //         /* =========================================================
// //            SECTION 1 — HERO / ABOUT HLC
// //         ========================================================= */
// //         .hlc-about-react{
// //           background:linear-gradient(180deg,#ffffff 0%, #f7f7fb 100%);
// //           padding:clamp(48px,6vw,88px) 0;
// //           overflow:hidden;
// //         }

// //         .hlc-about-react__inner{
// //           width:min(1200px,92vw);
// //           margin:auto;
// //         }

// //         .hlc-about-react__grid{
// //           display:grid;
// //           grid-template-columns:minmax(0,1.08fr) minmax(320px,.92fr);
// //           gap:clamp(24px,4vw,54px);
// //           align-items:center;
// //         }

// //         .hlc-about-react__content{
// //           min-width:0;
// //         }

// //         .hlc-about-react__eyebrow{
// //           margin:0 0 8px;
// //           font-size:11px;
// //           font-weight:700;
// //           letter-spacing:.18em;
// //           text-transform:uppercase;
// //           color:var(--about-magenta);
// //         }

// //         .hlc-about-react__content h1{
// //           font-size:clamp(32px,4.1vw,52px);
// //           line-height:1.04;
// //           letter-spacing:-.03em;
// //           margin:0 0 16px;
// //           color:var(--about-text);
// //           font-weight:600;
// //           max-width:11ch;
// //         }

// //         .hlc-about-react__lead{
// //           font-size:16px;
// //           line-height:1.8;
// //           color:#4d4b60;
// //           margin:0 0 28px;
// //           max-width:680px;
// //         }

// //         .hlc-about-react__highlights{
// //           display:grid;
// //           grid-template-columns:repeat(2,minmax(0,1fr));
// //           gap:14px 16px;
// //           margin-bottom:26px;
// //         }

// //         .hlc-about-react__highlight{
// //           display:flex;
// //           align-items:flex-start;
// //           gap:12px;
// //           padding:16px 16px;
// //           background:#fff;
// //           border:1px solid var(--about-line);
// //           box-shadow:0 10px 26px rgba(20,19,32,.06);
// //           transition:.32s ease;
// //           min-width:0;
// //         }

// //         .hlc-about-react__highlight:hover{
// //           transform:translateY(-4px);
// //           box-shadow:0 18px 38px rgba(155,31,108,.14);
// //           border-color:rgba(155,31,108,.34);
// //         }

// //         .hlc-about-react__dot{
// //           width:10px;
// //           height:10px;
// //           margin-top:6px;
// //           flex:0 0 10px;
// //           background:linear-gradient(135deg,var(--about-magenta),var(--about-plum));
// //         }

// //         .hlc-about-react__highlight-text{
// //           display:flex;
// //           flex-direction:column;
// //           gap:2px;
// //           min-width:0;
// //         }

// //         .hlc-about-react__highlight-text strong{
// //           font-size:14px;
// //           line-height:1.35;
// //           color:var(--about-navy);
// //         }

// //         .hlc-about-react__highlight-text span{
// //           font-size:13px;
// //           line-height:1.5;
// //           color:var(--about-muted);
// //         }

// //         .hlc-about-react__cta{
// //           display:flex;
// //           gap:14px;
// //           flex-wrap:wrap;
// //           margin-bottom:16px;
// //         }

// //         .hlc-about-react__btn-primary,
// //         .hlc-about-react__btn-outline{
// //           min-height:46px;
// //           padding:13px 20px;
// //           font-size:13px;
// //           font-weight:800;
// //           letter-spacing:.08em;
// //           text-transform:uppercase;
// //           text-decoration:none;
// //           border-radius:0;
// //           transition:.28s ease;
// //           display:inline-flex;
// //           align-items:center;
// //           justify-content:center;
// //         }

// //         .hlc-about-react__btn-primary{
// //           background:var(--about-magenta);
// //           color:#fff;
// //           border:1px solid var(--about-magenta);
// //           box-shadow:0 10px 24px rgba(155,31,108,.16);
// //         }

// //         .hlc-about-react__btn-primary:hover{
// //           background:var(--about-plum);
// //           border-color:var(--about-plum);
// //           transform:translateY(-2px);
// //         }

// //         .hlc-about-react__btn-outline{
// //           background:#fff;
// //           color:var(--about-magenta);
// //           border:1px solid rgba(155,31,108,.45);
// //         }

// //         .hlc-about-react__btn-outline:hover{
// //           background:rgba(155,31,108,.08);
// //           transform:translateY(-2px);
// //         }

// //         .hlc-about-react__note{
// //           font-size:13px;
// //           line-height:1.7;
// //           color:var(--about-muted);
// //           max-width:560px;
// //           margin:0;
// //         }

// //         .hlc-about-react__visual{
// //           display:flex;
// //           justify-content:flex-end;
// //         }

// //         .hlc-about-react__visual-box{
// //           position:relative;
// //           width:min(100%, 460px);
// //           background:linear-gradient(135deg,rgba(255,255,255,1) 0%,rgba(247,247,251,1) 100%);
// //           border:1px solid var(--about-line);
// //           padding:30px 28px;
// //           box-shadow:0 24px 46px rgba(20,19,32,.10);
// //           transition:.38s ease;
// //           overflow:hidden;
// //         }

// //         .hlc-about-react__visual-box::before{
// //           content:"";
// //           position:absolute;
// //           inset:0 auto 0 0;
// //           width:4px;
// //           background:linear-gradient(180deg,var(--about-magenta),var(--about-plum),var(--about-navy));
// //         }

// //         .hlc-about-react__visual-box:hover{
// //           transform:translateY(-6px);
// //           box-shadow:0 30px 60px rgba(20,19,32,.16);
// //         }

// //         .hlc-about-react__visual-top{
// //           margin-bottom:12px;
// //         }

// //         .hlc-about-react__visual-eyebrow{
// //           margin:0 0 6px;
// //           font-size:11px;
// //           font-weight:700;
// //           letter-spacing:.16em;
// //           text-transform:uppercase;
// //           color:var(--about-magenta);
// //         }

// //         .hlc-about-react__visual-box h2{
// //           margin:0;
// //           font-size:clamp(24px,2vw,30px);
// //           line-height:1.15;
// //           color:var(--about-navy);
// //           font-weight:800;
// //         }

// //         .hlc-about-react__visual-desc{
// //           font-size:14px;
// //           line-height:1.75;
// //           color:#555;
// //           margin:0 0 16px;
// //         }

// //         .hlc-about-react__visual-list{
// //           list-style:none;
// //           padding:0;
// //           margin:0 0 22px;
// //           display:grid;
// //           gap:10px;
// //         }

// //         .hlc-about-react__visual-list li{
// //           position:relative;
// //           padding-left:22px;
// //           font-size:14px;
// //           line-height:1.6;
// //           color:#444;
// //         }

// //         .hlc-about-react__visual-list li::before{
// //           content:"";
// //           position:absolute;
// //           left:0;
// //           top:8px;
// //           width:10px;
// //           height:10px;
// //           background:linear-gradient(135deg,var(--about-magenta),var(--about-plum));
// //         }

// //         .hlc-about-react__stats{
// //           display:grid;
// //           grid-template-columns:repeat(3,minmax(0,1fr));
// //           gap:10px;
// //           margin-top:4px;
// //         }

// //         .hlc-about-react__mini-stat{
// //           background:#fff;
// //           border:1px solid var(--about-line);
// //           padding:14px 10px;
// //           text-align:center;
// //           box-shadow:0 8px 20px rgba(20,19,32,.05);
// //         }

// //         .hlc-about-react__mini-stat strong{
// //           display:block;
// //           font-size:20px;
// //           line-height:1.1;
// //           color:var(--about-navy);
// //           font-weight:800;
// //         }

// //         .hlc-about-react__mini-stat span{
// //           display:block;
// //           margin-top:4px;
// //           font-size:12px;
// //           line-height:1.4;
// //           color:var(--about-muted);
// //         }

// //         /* =========================================================
// //            SECTION 2 — CEO
// //         ========================================================= */
// //         .hlc-ceo-react{
// //           position:relative;
// //           background:
// //             radial-gradient(circle at top left, rgba(155,31,108,.24), transparent 32%),
// //             radial-gradient(circle at bottom right, rgba(84,39,87,.28), transparent 34%),
// //             linear-gradient(135deg, #9b1f6c 0%, #542757 45%, #35335b 100%);
// //           padding:clamp(56px,7vw,96px) 0;
// //           overflow:hidden;
// //           color:#fff;
// //         }

// //         .hlc-ceo-react__inner{
// //           width:min(1200px,92vw);
// //           margin:auto;
// //         }

// //         .hlc-ceo-react__grid{
// //           display:grid;
// //           grid-template-columns:minmax(300px,.9fr) minmax(0,1.1fr);
// //           gap:clamp(24px,4vw,54px);
// //           align-items:center;
// //         }

// //         .hlc-ceo-react__image{
// //           min-width:0;
// //         }

// //         .hlc-ceo-react__image-box{
// //           position:relative;
// //           background:rgba(255,255,255,.06);
// //           border:1px solid rgba(255,255,255,.14);
// //           padding:16px;
// //           box-shadow:0 24px 56px rgba(0,0,0,.24);
// //           transition:.38s ease;
// //           overflow:hidden;
// //         }

// //         .hlc-ceo-react__image-box::before{
// //           content:"";
// //           position:absolute;
// //           inset:0 auto 0 0;
// //           width:4px;
// //           background:linear-gradient(180deg,var(--about-magenta),var(--about-plum),var(--about-navy));
// //         }

// //         .hlc-ceo-react__image-box:hover{
// //           transform:translateY(-8px);
// //           box-shadow:0 34px 72px rgba(0,0,0,.30);
// //         }

// //         .hlc-ceo-react__image-box img{
// //           width:100%;
// //           display:block;
// //           object-fit:cover;
// //           aspect-ratio:5 / 6;
// //         }

// //         .hlc-ceo-react__content{
// //           min-width:0;
// //         }

// //         .hlc-ceo-react__eyebrow{
// //           display:inline-block;
// //           font-size:11px;
// //           letter-spacing:.18em;
// //           text-transform:uppercase;
// //           color:#ffd6ef;
// //           margin-bottom:10px;
// //           font-weight:700;
// //         }

// //         .hlc-ceo-react__content h2{
// //           font-size:clamp(30px,3.4vw,44px);
// //           line-height:1.08;
// //           margin:0 0 18px;
// //           color:var(--about-white);
// //           font-weight:800;
// //           letter-spacing:-.02em;
// //         }

// //         .hlc-ceo-react__message{
// //           font-size:15px;
// //           line-height:1.8;
// //           color:var(--about-light);
// //           margin:0 0 14px;
// //         }

// //         .hlc-ceo-react__message:last-of-type{
// //           margin-bottom:0;
// //         }

// //         .hlc-ceo-react__signature{
// //           margin-top:24px;
// //           padding-top:16px;
// //           border-top:1px solid var(--about-line-white);
// //         }

// //         .hlc-ceo-react__signature strong{
// //           display:block;
// //           font-size:15px;
// //           color:#ffffff;
// //           font-weight:700;
// //         }

// //         .hlc-ceo-react__signature span{
// //           display:block;
// //           margin-top:4px;
// //           font-size:13px;
// //           color:var(--about-soft);
// //         }

// //         /* =========================================================
// //            SECTION 3 — JOURNEY
// //         ========================================================= */
// //         .hlc-journey-react{
// //           padding:clamp(90px,10vw,120px) 0;
// //           background:
// //             radial-gradient(1200px 600px at 90% -10%,rgba(155,31,108,.08),transparent 60%),
// //             linear-gradient(180deg,#f7f8fc 0%,#ffffff 100%);
// //         }

// //         .hlc-journey-react__inner{
// //           width:min(1200px,92vw);
// //           margin:auto;
// //         }

// //         .hlc-journey-react__head{
// //           max-width:760px;
// //           margin-bottom:70px;
// //         }

// //         .hlc-journey-react__tag{
// //           display:inline-block;
// //           font-size:12px;
// //           font-weight:800;
// //           letter-spacing:.18em;
// //           color:#9b1f6c;
// //         }

// //         .hlc-journey-react__head h2{
// //           font-size:clamp(34px,3.6vw,42px);
// //           margin:10px 0 14px;
// //           color:#1c1b29;
// //           line-height:1.15;
// //         }

// //         .hlc-journey-react__head p{
// //           font-size:15px;
// //           line-height:1.75;
// //           color:#55536a;
// //           margin:0;
// //         }

// //         .hlc-journey-react__timeline{
// //           display:grid;
// //           grid-template-columns:repeat(3,1fr);
// //           gap:36px;
// //           position:relative;
// //         }

// //         .hlc-journey-react__card{
// //           position:relative;
// //           padding-top:40px;
// //         }

// //         .hlc-journey-react__year{
// //           position:absolute;
// //           top:0;
// //           left:0;
// //           font-size:28px;
// //           font-weight:900;
// //           color:#9b1f6c;
// //         }

// //         .hlc-journey-react__year--highlight{
// //           color:#35335b;
// //         }

// //         .hlc-journey-react__box{
// //           background:#ffffff;
// //           border:1px solid #eceaf1;
// //           padding:28px 30px;
// //           box-shadow:0 18px 44px rgba(20,19,32,.10);
// //           transition:.35s ease;
// //         }

// //         .hlc-journey-react__box:hover{
// //           transform:translateY(-8px);
// //           box-shadow:0 28px 70px rgba(20,19,32,.18);
// //         }

// //         .hlc-journey-react__box h3{
// //           font-size:22px;
// //           margin:0 0 10px;
// //           color:#35335b;
// //         }

// //         .hlc-journey-react__box p{
// //           margin:0;
// //           font-size:14.5px;
// //           line-height:1.75;
// //           color:#4d4b60;
// //         }

// //         /* =========================================================
// //            SECTION 4 — CERTIFICATIONS
// //         ========================================================= */
// //         .hlc-cert{
// //           padding:clamp(50px,9vw,50px) 0;
// //           background:
// //             radial-gradient(circle at 20% 0%, rgba(155,31,108,.12), transparent 40%),
// //             linear-gradient(135deg,#9b1f6c 0%,#542757 45%,#35335b 100%);
// //           color:#fff;
// //           overflow:hidden;
// //           font-family:"Open Sans",system-ui;
// //         }

// //         .hlc-cert__inner{
// //           width:min(1200px,92vw);
// //           margin:auto;
// //         }

// //         .hlc-cert__head{
// //           text-align:center;
// //           max-width:760px;
// //           margin:0 auto 50px;
// //         }

// //         .cert-tag{
// //           font-size:11px;
// //           letter-spacing:.10em;
// //           font-weight:800;
// //           color:#ffd6ef;
// //         }

// //         .hlc-cert__head h2{
// //           font-size:clamp(20px,3.5vw,42px);
// //           margin:10px 0;
// //         }

// //         .hlc-cert__head p{
// //           font-size:15px;
// //           line-height:1.7;
// //           color:rgba(255,255,255,.85);
// //         }

// //         .hlc-cert-slider{
// //           overflow:hidden;
// //         }

// //         .hlc-cert-track{
// //           display:flex;
// //           gap:20px;
// //           width:max-content;
// //           animation:scrollCert 35s linear infinite;
// //         }

// //         .cert-card{
// //           min-width:260px;
// //           max-width:260px;
// //           background:rgba(255,255,255,.08);
// //           border:1px solid rgba(255,255,255,.18);
// //           backdrop-filter:blur(6px);
// //           padding:18px;
// //           text-align:center;
// //           transition:.3s;
// //         }

// //         .cert-card:hover{
// //           transform:translateY(-6px);
// //           background:rgba(255,255,255,.12);
// //         }

// //         .cert-img{
// //           height:90px;
// //           display:flex;
// //           align-items:center;
// //           justify-content:center;
// //           margin-bottom:12px;
// //         }

// //         .cert-img img{
// //           max-width:100%;
// //           max-height:100%;
// //           object-fit:contain;
// //         }

// //         .cert-card h3{
// //           font-size:15px;
// //           margin-bottom:6px;
// //         }

// //         .cert-card p{
// //           font-size:13px;
// //           line-height:1.5;
// //           color:rgba(255,255,255,.75);
// //         }

// //         @keyframes scrollCert{
// //           0%{ transform:translateX(0); }
// //           100%{ transform:translateX(-50%); }
// //         }

// //         .hlc-cert-slider:hover .hlc-cert-track{
// //           animation-play-state:paused;
// //         }

// //         /* =========================================================
// //            RESPONSIVE
// //         ========================================================= */
// //         @media (max-width: 1024px){
// //           .hlc-about-react{
// //             padding:56px 0 64px;
// //           }

// //           .hlc-about-react__grid{
// //             grid-template-columns:1fr;
// //             gap:28px;
// //           }

// //           .hlc-about-react__content h1{
// //             max-width:none;
// //           }

// //           .hlc-about-react__visual{
// //             justify-content:flex-start;
// //           }

// //           .hlc-about-react__visual-box{
// //             width:100%;
// //             max-width:none;
// //           }

// //           .hlc-ceo-react{
// //             padding:56px 0 70px;
// //           }

// //           .hlc-ceo-react__grid{
// //             gap:28px;
// //           }

// //           .hlc-ceo-react__content h2{
// //             font-size:34px;
// //           }

// //           .hlc-ceo-react__message{
// //             font-size:14px;
// //             line-height:1.75;
// //           }
// //         }

// //         @media (max-width: 992px){
// //           .hlc-journey-react__timeline{
// //             grid-template-columns:1fr;
// //             gap:42px;
// //           }

// //           .hlc-journey-react__year{
// //             position:static;
// //             margin-bottom:10px;
// //           }
// //         }

// //         @media (max-width: 900px){
// //           .hlc-ceo-react__grid{
// //             grid-template-columns:1fr;
// //           }

// //           .hlc-ceo-react__image{
// //             order:1;
// //           }

// //           .hlc-ceo-react__content{
// //             order:2;
// //           }
// //         }

// //         @media (max-width: 768px){
// //           .cert-card{
// //             min-width:220px;
// //             max-width:220px;
// //           }

// //           .hlc-cert-track{
// //             animation-duration:25s;
// //           }
// //         }

// //         @media (max-width: 767px){
// //           .hlc-about-react{
// //             padding:42px 0 50px;
// //           }

// //           .hlc-about-react__inner,
// //           .hlc-ceo-react__inner{
// //             width:min(1200px,94vw);
// //           }

// //           .hlc-about-react__eyebrow{
// //             font-size:10px;
// //           }

// //           .hlc-about-react__content h1{
// //             font-size:clamp(28px,8vw,38px);
// //             line-height:1.06;
// //             margin-bottom:12px;
// //           }

// //           .hlc-about-react__lead{
// //             font-size:14px;
// //             line-height:1.7;
// //             margin-bottom:20px;
// //           }

// //           .hlc-about-react__highlights{
// //             grid-template-columns:1fr;
// //             gap:10px;
// //             margin-bottom:20px;
// //           }

// //           .hlc-about-react__highlight{
// //             padding:14px 14px;
// //           }

// //           .hlc-about-react__highlight-text strong{
// //             font-size:14px;
// //           }

// //           .hlc-about-react__highlight-text span{
// //             font-size:12px;
// //           }

// //           .hlc-about-react__cta{
// //             flex-direction:column;
// //             gap:10px;
// //             margin-bottom:14px;
// //           }

// //           .hlc-about-react__btn-primary,
// //           .hlc-about-react__btn-outline{
// //             width:100%;
// //             min-height:44px;
// //             padding:12px 16px;
// //             font-size:12px;
// //           }

// //           .hlc-about-react__note{
// //             font-size:12px;
// //             line-height:1.6;
// //           }

// //           .hlc-about-react__visual-box{
// //             padding:22px 18px;
// //           }

// //           .hlc-about-react__visual-box h2{
// //             font-size:24px;
// //           }

// //           .hlc-about-react__visual-desc{
// //             font-size:13px;
// //             line-height:1.65;
// //           }

// //           .hlc-about-react__visual-list li{
// //             font-size:13px;
// //           }

// //           .hlc-about-react__stats{
// //             grid-template-columns:1fr 1fr 1fr;
// //             gap:8px;
// //           }

// //           .hlc-about-react__mini-stat{
// //             padding:12px 8px;
// //           }

// //           .hlc-about-react__mini-stat strong{
// //             font-size:18px;
// //           }

// //           .hlc-about-react__mini-stat span{
// //             font-size:11px;
// //           }

// //           .hlc-ceo-react{
// //             padding:42px 0 52px;
// //           }

// //           .hlc-ceo-react__image-box{
// //             padding:12px;
// //           }

// //           .hlc-ceo-react__eyebrow{
// //             font-size:10px;
// //             margin-bottom:8px;
// //           }

// //           .hlc-ceo-react__content h2{
// //             font-size:28px;
// //             margin-bottom:14px;
// //           }

// //           .hlc-ceo-react__message{
// //             font-size:13px;
// //             line-height:1.7;
// //             margin-bottom:12px;
// //           }

// //           .hlc-ceo-react__signature{
// //             margin-top:18px;
// //             padding-top:14px;
// //           }

// //           .hlc-ceo-react__signature strong{
// //             font-size:14px;
// //           }

// //           .hlc-ceo-react__signature span{
// //             font-size:12px;
// //           }
// //         }

// //         @media (max-width: 480px){
// //           .hlc-about-react__inner,
// //           .hlc-ceo-react__inner,
// //           .hlc-journey-react__inner{
// //             width:min(1200px,92vw);
// //           }

// //           .hlc-about-react__content h1{
// //             font-size:26px;
// //           }

// //           .hlc-about-react__lead{
// //             font-size:13px;
// //           }

// //           .hlc-about-react__visual-box{
// //             padding:20px 16px;
// //           }

// //           .hlc-about-react__visual-box h2{
// //             font-size:22px;
// //           }

// //           .hlc-about-react__stats{
// //             grid-template-columns:1fr;
// //           }

// //           .hlc-about-react__mini-stat strong{
// //             font-size:17px;
// //           }

// //           .hlc-ceo-react{
// //             padding:36px 0 46px;
// //           }

// //           .hlc-ceo-react__content h2{
// //             font-size:24px;
// //           }

// //           .hlc-ceo-react__message{
// //             font-size:12px;
// //             line-height:1.65;
// //           }

// //           .hlc-ceo-react__image-box{
// //             padding:10px;
// //           }
// //         }
// //       `}</style>

// //       <div className="about-page-root">
// //         {/* =======================================================
// //             SECTION 1 — HERO
// //         ======================================================= */}
// //         <section className="hlc-about-react" id="about-hlc">
// //           <div className="hlc-about-react__inner">
// //             <div className="hlc-about-react__grid">
// //               {/* LEFT CONTENT */}
// //               <div
// //                 className="hlc-about-react__content about-animate-up"
// //                 ref={addToRefs}
// //               >
// //                 <p className="hlc-about-react__eyebrow">About HLC</p>
// //                 <h1>Built on Legacy. Driven by Innovation.</h1>

// //                 <p className="hlc-about-react__lead">
// //                   With a long-standing legacy in the lighting industry, HLC
// //                   (High Lite Concern) delivers innovative, efficient and
// //                   design-forward LED solutions for indoor and outdoor
// //                   applications — built to elevate spaces with reliability,
// //                   performance and style.
// //                 </p>

// //                 <div className="hlc-about-react__highlights">
// //                   <div className="hlc-about-react__highlight">
// //                     <span className="hlc-about-react__dot"></span>
// //                     <div className="hlc-about-react__highlight-text">
// //                       <strong>50+ Years</strong>
// //                       <span>legacy in lighting</span>
// //                     </div>
// //                   </div>

// //                   <div className="hlc-about-react__highlight">
// //                     <span className="hlc-about-react__dot"></span>
// //                     <div className="hlc-about-react__highlight-text">
// //                       <strong>Established 1970</strong>
// //                       <span>family-led vision</span>
// //                     </div>
// //                   </div>

// //                   <div className="hlc-about-react__highlight">
// //                     <span className="hlc-about-react__dot"></span>
// //                     <div className="hlc-about-react__highlight-text">
// //                       <strong>Expanded 2018</strong>
// //                       <span>modern manufacturing</span>
// //                     </div>
// //                   </div>

// //                   <div className="hlc-about-react__highlight">
// //                     <span className="hlc-about-react__dot"></span>
// //                     <div className="hlc-about-react__highlight-text">
// //                       <strong>ISO 9001</strong>
// //                       <span>quality commitment</span>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 <div className="hlc-about-react__cta">
// //                   <a href="#hlc-ceo" className="hlc-about-react__btn-primary">
// //                     From Our CEO
// //                   </a>
// //                   <a
// //                     href="#hlc-journey"
// //                     className="hlc-about-react__btn-outline"
// //                   >
// //                     Our Journey
// //                   </a>
// //                 </div>

// //                 <p className="hlc-about-react__note">
// //                   Trusted by partners, distributors and dealers — powering
// //                   homes, workplaces and projects with dependable LED solutions
// //                   across Pakistan.
// //                 </p>
// //               </div>

// //               {/* RIGHT PANEL */}
// //               <div
// //                 className="hlc-about-react__visual about-animate-up about-delay-1"
// //                 ref={addToRefs}
// //               >
// //                 <div className="hlc-about-react__visual-box">
// //                   <div className="hlc-about-react__visual-top">
// //                     <p className="hlc-about-react__visual-eyebrow">Why HLC</p>
// //                     <h2>Design. Performance. Trust.</h2>
// //                   </div>

// //                   <p className="hlc-about-react__visual-desc">
// //                     For decades, HLC has remained committed to quality
// //                     engineering, modern aesthetics and energy-efficient
// //                     innovation for residential, commercial and industrial
// //                     lighting projects.
// //                   </p>

// //                   <ul className="hlc-about-react__visual-list">
// //                     <li>Advanced LED Technology</li>
// //                     <li>Nationwide Dealer Network</li>
// //                     <li>
// //                       Residential, Commercial &amp; Industrial Solutions
// //                     </li>
// //                   </ul>

// //                   <div className="hlc-about-react__stats">
// //                     <div className="hlc-about-react__mini-stat">
// //                       <strong>1970</strong>
// //                       <span>Founded</span>
// //                     </div>
// //                     <div className="hlc-about-react__mini-stat">
// //                       <strong>50+</strong>
// //                       <span>Years</span>
// //                     </div>
// //                     <div className="hlc-about-react__mini-stat">
// //                       <strong>ISO</strong>
// //                       <span>Focused</span>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </section>

// //         {/* =======================================================
// //             SECTION 2 — CEO
// //         ======================================================= */}
// //         <section className="hlc-ceo-react" id="hlc-ceo">
// //           <div className="hlc-ceo-react__inner">
// //             <div className="hlc-ceo-react__grid">
// //               {/* IMAGE */}
// //               <div
// //                 className="hlc-ceo-react__image about-animate-up"
// //                 ref={addToRefs}
// //               >
// //                 <div className="hlc-ceo-react__image-box">
// //                   <img src={ceo} alt="CEO - HLC Lighting" />
// //                 </div>
// //               </div>

// //               {/* MESSAGE */}
// //               <div
// //                 className="hlc-ceo-react__content about-animate-up about-delay-1"
// //                 ref={addToRefs}
// //               >
// //                 <span className="hlc-ceo-react__eyebrow">From Our CEO</span>
// //                 <h2>Leading with Integrity, Innovation &amp; Trust</h2>

// //                 <p className="hlc-ceo-react__message">
// //                   Since our inception, HLC has been driven by a simple yet
// //                   powerful belief: lighting is not just about illumination—it is
// //                   about enhancing lives, empowering businesses, and shaping
// //                   environments.
// //                 </p>

// //                 <p className="hlc-ceo-react__message">
// //                   Over the decades, we have continuously evolved by embracing
// //                   innovation, investing in modern manufacturing, and maintaining
// //                   uncompromising quality standards. Our commitment is to deliver
// //                   reliable, energy-efficient and aesthetically refined LED
// //                   solutions that our partners can trust.
// //                 </p>

// //                 <p className="hlc-ceo-react__message">
// //                   As we look toward the future, HLC remains dedicated to
// //                   sustainability, customer satisfaction, and long-term
// //                   partnerships—lighting the way forward with responsibility and
// //                   excellence.
// //                 </p>

// //                 <div className="hlc-ceo-react__signature">
// //                   <strong>— Chief Executive Officer</strong>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </section>

// //         {/* =======================================================
// //             SECTION 3 — JOURNEY
// //         ======================================================= */}
// //         <section className="hlc-journey-react" id="hlc-journey">
// //           <div className="hlc-journey-react__inner">
// //             <div
// //               className="hlc-journey-react__head about-reveal"
// //               ref={addToRefs}
// //             >
// //               <span className="hlc-journey-react__tag">OUR JOURNEY</span>
// //               <h2>Decades of Excellence in Lighting Innovation</h2>
// //               <p>
// //                 From a legacy-driven foundation to a future-focused LED brand,
// //                 HLC's journey reflects consistency, trust and continuous
// //                 innovation.
// //               </p>
// //             </div>

// //             <div className="hlc-journey-react__timeline">
// //               <div
// //                 className="hlc-journey-react__card about-reveal"
// //                 ref={addToRefs}
// //               >
// //                 <div className="hlc-journey-react__year">1970</div>
// //                 <div className="hlc-journey-react__box">
// //                   <h3>Foundation &amp; Trust</h3>
// //                   <p>
// //                     HLC (High Lite Concern) began its journey with a clear
// //                     vision — delivering dependable lighting solutions built on
// //                     quality, craftsmanship and long-term customer relationships.
// //                   </p>
// //                 </div>
// //               </div>

// //               <div
// //                 className="hlc-journey-react__card about-reveal about-delay-1"
// //                 ref={addToRefs}
// //               >
// //                 <div className="hlc-journey-react__year">2018</div>
// //                 <div className="hlc-journey-react__box">
// //                   <h3>Modern Expansion</h3>
// //                   <p>
// //                     The brand entered a new phase with upgraded manufacturing,
// //                     advanced LED technologies and internationally aligned quality
// //                     processes.
// //                   </p>
// //                 </div>
// //               </div>

// //               <div
// //                 className="hlc-journey-react__card about-reveal about-delay-2"
// //                 ref={addToRefs}
// //               >
// //                 <div className="hlc-journey-react__year hlc-journey-react__year--highlight">
// //                   Today
// //                 </div>
// //                 <div className="hlc-journey-react__box">
// //                   <h3>Innovation-Led Growth</h3>
// //                   <p>
// //                     Today, HLC stands as a trusted national LED lighting brand,
// //                     delivering energy-efficient solutions for residential,
// //                     commercial, industrial and outdoor applications.
// //                   </p>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </section>

// //         {/* =======================================================
// //             SECTION 4 — WALL OF CERTIFICATION (Firebase-powered)
// //         ======================================================= */}
// //         <section className="hlc-cert" id="hlc-cert">
// //           <div className="hlc-cert__inner">

// //             {/* HEADER */}
// //             <div className="hlc-cert__head about-reveal" ref={addToRefs}>
// //               <span className="cert-tag">WALL OF CERTIFICATION</span>
// //               <h2>Recognized for Quality, Innovation &amp; Trust</h2>
// //               <p>
// //                 Our certifications and recognitions reflect our commitment to
// //                 quality, global standards, and trusted performance in the
// //                 lighting industry.
// //               </p>
// //             </div>

// //             {/* SLIDER — dynamic from Firebase */}
// //             {certificates.length === 0 ? (
// //               /* Loading / empty state */
// //               <div className="hlc-cert-empty">
// //                 <p>Loading certifications…</p>
// //               </div>
// //             ) : (
// //               <div className="hlc-cert-slider">
// //                 <div className="hlc-cert-track">
// //                   {sliderCards.map((cert, index) => (
// //                     <div className="cert-card" key={`${cert.id}-${index}`}>
// //                       <div className="cert-img">
// //                         {cert.image ? (
// //                           <img src={cert.image} alt={cert.title} />
// //                         ) : (
// //                           <div className="cert-img-placeholder">
// //                             <span>🏆</span>
// //                           </div>
// //                         )}
// //                       </div>
// //                       <h3>{cert.title}</h3>
// //                       <p>{cert.desc}</p>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             )}

// //           </div>
// //         </section>

// //       </div>

// //       <HlcFooter />
// //     </>
// //   );
// // }

// import React, { useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import Navbar from "../components/Navbar";
// import HlcFooter from "../components/HlcFooter";
// import ceo from "../assets/ceo.jpeg";
// import { db } from "../firebase";
// import { ref as dbRef, onValue } from "firebase/database";

// export default function AboutUsPage() {
//   const animatedRefs = useRef([]);
//   const [certificates, setCertificates] = useState([]);

//   useEffect(() => {
//     const certRef = dbRef(db, "certificates");
//     onValue(certRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         setCertificates(Object.entries(data).map(([id, value]) => ({ id, ...value })));
//       } else {
//         setCertificates([]);
//       }
//     });
//   }, []);

//   useEffect(() => {
//     const elements = animatedRefs.current.filter(Boolean);
//     if (!elements.length) return;
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("show");
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );
//     elements.forEach((el) => observer.observe(el));
//     return () => observer.disconnect();
//   }, []);

//   const addToRefs = (el) => {
//     if (el && !animatedRefs.current.includes(el)) {
//       animatedRefs.current.push(el);
//     }
//   };

//   const sliderCards = certificates.length > 0
//     ? [...certificates, ...certificates]
//     : [];

//   return (
//     <>
//       <Navbar />
//   <style>{`
//         :root{
//           --about-magenta:#9b1f6c;
//           --about-plum:#542757;
//           --about-navy:#35335b;
//           --about-text:#141320;
//           --about-muted:#6b677a;
//           --about-line:#eceaf1;
//           --about-bg:#f7f7fb;
//           --about-white:#ffffff;
//           --about-light:rgba(255,255,255,.88);
//           --about-soft:rgba(255,255,255,.74);
//           --about-line-white:rgba(255,255,255,.14);
//         }

//         .about-page-root{
//           width:100%;
//           overflow:hidden;
//           font-family:"Open Sans",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
//           background:#fff;
//           margin-top:40px;
//         }

//         /* SHARED ANIMATION */
//         .about-animate-up,
//         .about-reveal{
//           opacity:0;
//           transform:translateY(28px);
//           transition:opacity .7s ease,transform .7s ease;
//         }
//         .about-animate-up.show,
//         .about-reveal.show{ opacity:1; transform:none; }
//         .about-delay-1{ transition-delay:.12s; }
//         .about-delay-2{ transition-delay:.24s; }

//         /* =========================================================
//            SECTION 1 — HERO
//         ========================================================= */
//         .hlc-about-react{
//           background:linear-gradient(180deg,#ffffff 0%,#f7f7fb 100%);
//           padding:clamp(36px,5vw,80px) 0;
//           overflow:hidden;
//         }
//         .hlc-about-react__inner{
//           width:min(1200px,92vw);
//           margin:auto;
//         }
//         .hlc-about-react__grid{
//           display:grid;
//           grid-template-columns:minmax(0,1.08fr) minmax(300px,.92fr);
//           gap:clamp(20px,3vw,50px);
//           align-items:center;
//         }
//         .hlc-about-react__eyebrow{
//           margin:0 0 6px;
//           font-size:11px;
//           font-weight:700;
//           letter-spacing:.18em;
//           text-transform:uppercase;
//           color:var(--about-magenta);
//           margin-top:20px
//         }
//         .hlc-about-react__content h1{
//           font-size:clamp(26px,3.8vw,52px);
//           line-height:1.06;
//           letter-spacing:-.03em;
//           margin:0 0 14px;
//           color:var(--about-text);
//           font-weight:600;
//           max-width:13ch;
//         }
//         .hlc-about-react__lead{
//           font-size:15px;
//           line-height:1.75;
//           color:#4d4b60;
//           margin:0 0 22px;
//           max-width:660px;
//         }
//         .hlc-about-react__highlights{
//           display:grid;
//           grid-template-columns:repeat(2,minmax(0,1fr));
//           gap:10px 12px;
//           margin-bottom:22px;
//         }
//         .hlc-about-react__highlight{
//           display:flex;
//           align-items:flex-start;
//           gap:10px;
//           padding:14px;
//           background:#fff;
//           border:1px solid var(--about-line);
//           box-shadow:0 8px 20px rgba(20,19,32,.05);
//           transition:.3s ease;
//         }
//         .hlc-about-react__highlight:hover{
//           transform:translateY(-3px);
//           box-shadow:0 14px 32px rgba(155,31,108,.12);
//           border-color:rgba(155,31,108,.3);
//         }
//         .hlc-about-react__dot{
//           width:9px;
//           height:9px;
//           margin-top:5px;
//           flex:0 0 9px;
//           background:linear-gradient(135deg,var(--about-magenta),var(--about-plum));
//         }
//         .hlc-about-react__highlight-text{ display:flex; flex-direction:column; gap:2px; min-width:0; }
//         .hlc-about-react__highlight-text strong{ font-size:13px; line-height:1.3; color:var(--about-navy); }
//         .hlc-about-react__highlight-text span{ font-size:12px; line-height:1.45; color:var(--about-muted); }
//         .hlc-about-react__cta{
//           display:flex;
//           gap:12px;
//           flex-wrap:wrap;
//           margin-bottom:14px;
//         }
//         .hlc-about-react__btn-primary,
//         .hlc-about-react__btn-outline{
//           min-height:42px;
//           padding:11px 18px;
//           font-size:12px;
//           font-weight:800;
//           letter-spacing:.08em;
//           text-transform:uppercase;
//           text-decoration:none;
//           border-radius:0;
//           transition:.26s ease;
//           display:inline-flex;
//           align-items:center;
//           justify-content:center;
//         }
//         .hlc-about-react__btn-primary{
//           background:var(--about-magenta);
//           color:#fff;
//           border:1px solid var(--about-magenta);
//           box-shadow:0 8px 20px rgba(155,31,108,.14);
//         }
//         .hlc-about-react__btn-primary:hover{ background:var(--about-plum); border-color:var(--about-plum); transform:translateY(-2px); }
//         .hlc-about-react__btn-outline{
//           background:#fff;
//           color:var(--about-magenta);
//           border:1px solid rgba(155,31,108,.4);
//         }
//         .hlc-about-react__btn-outline:hover{ background:rgba(155,31,108,.07); transform:translateY(-2px); }
//         .hlc-about-react__note{
//           font-size:13px;
//           line-height:1.65;
//           color:var(--about-muted);
//           max-width:540px;
//           margin:0;
//         }
//         .hlc-about-react__visual{ display:flex; justify-content:flex-end; }
//         .hlc-about-react__visual-box{
//           position:relative;
//           width:min(100%,440px);
//           background:linear-gradient(135deg,#fff 0%,#f7f7fb 100%);
//           border:1px solid var(--about-line);
//           padding:26px 24px;
//           box-shadow:0 20px 40px rgba(20,19,32,.09);
//           transition:.35s ease;
//           overflow:hidden;
//         }
//         .hlc-about-react__visual-box::before{
//           content:"";
//           position:absolute;
//           inset:0 auto 0 0;
//           width:4px;
//           background:linear-gradient(180deg,var(--about-magenta),var(--about-plum),var(--about-navy));
//         }
//         .hlc-about-react__visual-box:hover{ transform:translateY(-5px); box-shadow:0 28px 54px rgba(20,19,32,.14); }
//         .hlc-about-react__visual-eyebrow{
//           margin:0 0 5px;
//           font-size:11px;
//           font-weight:700;
//           letter-spacing:.16em;
//           text-transform:uppercase;
//           color:var(--about-magenta);
//         }
//         .hlc-about-react__visual-box h2{
//           margin:0 0 10px;
//           font-size:clamp(20px,2vw,28px);
//           line-height:1.15;
//           color:var(--about-navy);
//           font-weight:800;
//         }
//         .hlc-about-react__visual-desc{
//           font-size:13px;
//           line-height:1.7;
//           color:#555;
//           margin:0 0 14px;
//         }
//         .hlc-about-react__visual-list{
//           list-style:none;
//           padding:0;
//           margin:0 0 18px;
//           display:grid;
//           gap:8px;
//         }
//         .hlc-about-react__visual-list li{
//           position:relative;
//           padding-left:20px;
//           font-size:13px;
//           line-height:1.55;
//           color:#444;
//         }
//         .hlc-about-react__visual-list li::before{
//           content:"";
//           position:absolute;
//           left:0;
//           top:7px;
//           width:9px;
//           height:9px;
//           background:linear-gradient(135deg,var(--about-magenta),var(--about-plum));
//         }
//         .hlc-about-react__stats{
//           display:grid;
//           grid-template-columns:repeat(3,minmax(0,1fr));
//           gap:8px;
//           margin-top:4px;
//         }
//         .hlc-about-react__mini-stat{
//           background:#fff;
//           border:1px solid var(--about-line);
//           padding:12px 8px;
//           text-align:center;
//           box-shadow:0 6px 16px rgba(20,19,32,.04);
//         }
//         .hlc-about-react__mini-stat strong{
//           display:block;
//           font-size:18px;
//           line-height:1.1;
//           color:var(--about-navy);
//           font-weight:800;
//         }
//         .hlc-about-react__mini-stat span{
//           display:block;
//           margin-top:3px;
//           font-size:11px;
//           line-height:1.35;
//           color:var(--about-muted);
//         }

//         /* =========================================================
//            SECTION 2 — CEO
//         ========================================================= */
//         .hlc-ceo-react{
//           position:relative;
//           background:
//             radial-gradient(circle at top left,rgba(155,31,108,.22),transparent 32%),
//             radial-gradient(circle at bottom right,rgba(84,39,87,.26),transparent 34%),
//             linear-gradient(135deg,#9b1f6c 0%,#542757 45%,#35335b 100%);
//           padding:clamp(40px,6vw,88px) 0;
//           overflow:hidden;
//           color:#fff;
//         }
//         .hlc-ceo-react__inner{
//           width:min(1200px,92vw);
//           margin:auto;
//         }
//         .hlc-ceo-react__grid{
//           display:grid;
//           grid-template-columns:minmax(260px,.85fr) minmax(0,1.15fr);
//           gap:clamp(20px,3.5vw,50px);
//           align-items:center;
//         }
//         .hlc-ceo-react__image-box{
//           position:relative;
//           background:rgba(255,255,255,.06);
//           border:1px solid rgba(255,255,255,.14);
//           padding:14px;
//           box-shadow:0 20px 48px rgba(0,0,0,.22);
//           transition:.35s ease;
//           overflow:hidden;
//         }
//         .hlc-ceo-react__image-box::before{
//           content:"";
//           position:absolute;
//           inset:0 auto 0 0;
//           width:4px;
//           background:linear-gradient(180deg,var(--about-magenta),var(--about-plum),var(--about-navy));
//         }
//         .hlc-ceo-react__image-box:hover{ transform:translateY(-6px); box-shadow:0 30px 64px rgba(0,0,0,.28); }
//         .hlc-ceo-react__image-box img{
//           width:100%;
//           display:block;
//           object-fit:cover;
//           aspect-ratio:5/6;
//         }
//         .hlc-ceo-react__eyebrow{
//           display:inline-block;
//           font-size:11px;
//           letter-spacing:.18em;
//           text-transform:uppercase;
//           color:#ffd6ef;
//           margin-bottom:8px;
//           font-weight:700;
//         }
//         .hlc-ceo-react__content h2{
//           font-size:clamp(24px,3vw,42px);
//           line-height:1.1;
//           margin:0 0 16px;
//           color:#fff;
//           font-weight:800;
//           letter-spacing:-.02em;
//         }
//         .hlc-ceo-react__message{
//           font-size:14px;
//           line-height:1.78;
//           color:var(--about-light);
//           margin:0 0 12px;
//         }
//         .hlc-ceo-react__signature{
//           margin-top:20px;
//           padding-top:14px;
//           border-top:1px solid var(--about-line-white);
//         }
//         .hlc-ceo-react__signature strong{ display:block; font-size:14px; color:#fff; font-weight:700; }
//         .hlc-ceo-react__signature span{ display:block; margin-top:3px; font-size:12px; color:var(--about-soft); }

//         /* =========================================================
//            SECTION 3 — JOURNEY
//         ========================================================= */
//         .hlc-journey-react{
//           padding:clamp(56px,8vw,100px) 0;
//           background:
//             radial-gradient(1000px 500px at 90% -10%,rgba(155,31,108,.07),transparent 60%),
//             linear-gradient(180deg,#f7f8fc 0%,#ffffff 100%);
//         }
//         .hlc-journey-react__inner{
//           width:min(1200px,92vw);
//           margin:auto;
//         }
//         .hlc-journey-react__head{
//           max-width:720px;
//           margin-bottom:48px;
//         }
//         .hlc-journey-react__tag{
//           display:inline-block;
//           font-size:11px;
//           font-weight:800;
//           letter-spacing:.18em;
//           color:#9b1f6c;
//         }
//         .hlc-journey-react__head h2{
//           font-size:clamp(26px,3.2vw,40px);
//           margin:8px 0 12px;
//           color:#1c1b29;
//           line-height:1.15;
//         }
//         .hlc-journey-react__head p{
//           font-size:14px;
//           line-height:1.72;
//           color:#55536a;
//           margin:0;
//         }
//         .hlc-journey-react__timeline{
//           display:grid;
//           grid-template-columns:repeat(3,1fr);
//           gap:28px;
//         }
//         .hlc-journey-react__card{ position:relative; padding-top:36px; }
//         .hlc-journey-react__year{
//           position:absolute;
//           top:0; left:0;
//           font-size:26px;
//           font-weight:900;
//           color:#9b1f6c;
//         }
//         .hlc-journey-react__year--highlight{ color:#35335b; }
//         .hlc-journey-react__box{
//           background:#fff;
//           border:1px solid #eceaf1;
//           padding:24px 26px;
//           box-shadow:0 14px 36px rgba(20,19,32,.08);
//           transition:.32s ease;
//         }
//         .hlc-journey-react__box:hover{ transform:translateY(-6px); box-shadow:0 24px 58px rgba(20,19,32,.15); }
//         .hlc-journey-react__box h3{ font-size:20px; margin:0 0 8px; color:#35335b; }
//         .hlc-journey-react__box p{ margin:0; font-size:13.5px; line-height:1.72; color:#4d4b60; }

//         /* =========================================================
//            SECTION 4 — CERTIFICATIONS
//         ========================================================= */
//         .hlc-cert{
//           padding:clamp(40px,7vw,70px) 0;
//           background:
//             radial-gradient(circle at 20% 0%,rgba(155,31,108,.12),transparent 40%),
//             linear-gradient(135deg,#9b1f6c 0%,#542757 45%,#35335b 100%);
//           color:#fff;
//           overflow:hidden;
//           font-family:"Open Sans",system-ui;
//         }
//         .hlc-cert__inner{ width:min(1200px,92vw); margin:auto; }
//         .hlc-cert__head{ text-align:center; max-width:720px; margin:0 auto 40px; }
//         .cert-tag{ font-size:11px; letter-spacing:.10em; font-weight:800; color:#ffd6ef; }
//         .hlc-cert__head h2{ font-size:clamp(18px,3.2vw,38px); margin:8px 0; }
//         .hlc-cert__head p{ font-size:14px; line-height:1.68; color:rgba(255,255,255,.85); }
//         .hlc-cert-slider{ overflow:hidden; }
//         .hlc-cert-track{
//           display:flex;
//           gap:16px;
//           width:max-content;
//           animation:scrollCert 35s linear infinite;
//           align-items:stretch;
//         }
//         .cert-card{
//           min-width:230px;
//           max-width:230px;
//           background:rgba(255,255,255,.08);
//           border:1px solid rgba(255,255,255,.18);
//           backdrop-filter:blur(6px);
//           padding:16px;
//           text-align:center;
//           transition:.3s;
//           display:flex;
//           flex-direction:column;
//           align-items:center;
//           box-sizing:border-box;
//         }
//         .cert-card:hover{ transform:translateY(-5px); background:rgba(255,255,255,.12); }
//         .cert-img{
//           height:80px;
//           width:100%;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           margin-bottom:10px;
//           flex-shrink:0;
//         }
//         .cert-img img{ max-width:100%; max-height:100%; object-fit:contain; }
//         .cert-card h3{
//           font-size:14px;
//           margin-bottom:5px;
//           word-break:break-word;
//           overflow-wrap:break-word;
//           line-height:1.4;
//           width:100%;
//         }
//         .cert-card p{
//           font-size:12px;
//           line-height:1.5;
//           color:rgba(255,255,255,.75);
//           margin:0;
//           word-break:break-word;
//           overflow-wrap:break-word;
//           width:100%;
//         }
//         @keyframes scrollCert{
//           0%{ transform:translateX(0); }
//           100%{ transform:translateX(-50%); }
//         }
//         .hlc-cert-slider:hover .hlc-cert-track{ animation-play-state:paused; }

//         /* =========================================================
//            TABLET
//         ========================================================= */
//         @media (max-width:1024px){
//           .hlc-about-react__grid{ grid-template-columns:1fr; gap:24px; }
//           .hlc-about-react__content h1{ max-width:none; }
//           .hlc-about-react__visual{ justify-content:flex-start; }
//           .hlc-about-react__visual-box{ width:100%; max-width:none; }
//           .hlc-ceo-react__grid{ gap:24px; }
//         }
//         @media (max-width:992px){
//           .hlc-journey-react__timeline{ grid-template-columns:1fr; gap:36px; }
//           .hlc-journey-react__year{ position:static; margin-bottom:8px; }
//         }
//         @media (max-width:900px){
//           .hlc-ceo-react__grid{ grid-template-columns:1fr; }
//           .hlc-ceo-react__image{ order:1; }
//           .hlc-ceo-react__content{ order:2; }
//         }

//         /* =========================================================
//            MOBILE — COMPACT PROFESSIONAL LAYOUT
//         ========================================================= */
//         @media (max-width:767px){

//           /* --- HERO SECTION --- */
//           .hlc-about-react{
//             padding:28px 0 36px;
//           }
//           .hlc-about-react__inner,
//           .hlc-ceo-react__inner,
//           .hlc-journey-react__inner{
//             width:min(1200px,93vw);
//           }
//           .hlc-about-react__eyebrow{ font-size:10px; }
//           .hlc-about-react__content h1{
//             font-size:22px;
//             line-height:1.1;
//             margin-bottom:10px;
//             max-width:none;
//           }
//           .hlc-about-react__lead{
//             font-size:13px;
//             line-height:1.65;
//             margin-bottom:16px;
//           }

//           /* 2-col highlights on mobile */
//           .hlc-about-react__highlights{
//             grid-template-columns:repeat(2,minmax(0,1fr));
//             gap:8px;
//             margin-bottom:16px;
//           }
//           .hlc-about-react__highlight{ padding:11px 10px; gap:8px; }
//           .hlc-about-react__dot{ width:8px; height:8px; flex:0 0 8px; margin-top:4px; }
//           .hlc-about-react__highlight-text strong{ font-size:12px; }
//           .hlc-about-react__highlight-text span{ font-size:11px; }

//           /* CTAs in a row */
//           .hlc-about-react__cta{
//             flex-direction:row;
//             gap:8px;
//             margin-bottom:12px;
//           }
//           .hlc-about-react__btn-primary,
//           .hlc-about-react__btn-outline{
//             flex:1;
//             min-height:38px;
//             padding:10px 10px;
//             font-size:11px;
//           }
//           .hlc-about-react__note{ font-size:12px; line-height:1.6; }

//           /* Visual box compact */
//           .hlc-about-react__visual-box{ padding:16px 14px; }
//           .hlc-about-react__visual-box h2{ font-size:18px; margin-bottom:8px; }
//           .hlc-about-react__visual-desc{ font-size:12px; line-height:1.6; margin-bottom:10px; }
//           .hlc-about-react__visual-list{ gap:6px; margin-bottom:12px; }
//           .hlc-about-react__visual-list li{ font-size:12px; padding-left:16px; }
//           .hlc-about-react__visual-list li::before{ width:8px; height:8px; top:6px; }

//           /* Stats always 3-col row on mobile */
//           .hlc-about-react__stats{
//             grid-template-columns:repeat(3,minmax(0,1fr));
//             gap:6px;
//           }
//           .hlc-about-react__mini-stat{ padding:10px 6px; }
//           .hlc-about-react__mini-stat strong{ font-size:15px; }
//           .hlc-about-react__mini-stat span{ font-size:10px; }

//           /* --- CEO SECTION --- */
//           .hlc-ceo-react{
//             padding:28px 0 36px;
//           }

//           /* Side-by-side on mobile: small image left, text right */
//           .hlc-ceo-react__grid{
//             grid-template-columns:minmax(0,1fr) minmax(0,1.6fr) !important;
//             gap:14px;
//             align-items:start;
//           }
//           .hlc-ceo-react__image{ order:1 !important; }
//           .hlc-ceo-react__content{ order:2 !important; }

//           .hlc-ceo-react__image-box{
//             padding:8px;
//           }
//           /* Compact portrait on mobile */
//           .hlc-ceo-react__image-box img{
//             aspect-ratio:3/4;
//             width:100%;
//           }
//           .hlc-ceo-react__eyebrow{ font-size:10px; margin-bottom:6px; }
//           .hlc-ceo-react__content h2{
//             font-size:16px;
//             margin-bottom:10px;
//             line-height:1.2;
//             letter-spacing:-.01em;
//           }
//           .hlc-ceo-react__message{
//             font-size:12px;
//             line-height:1.65;
//             margin-bottom:9px;
//           }
//           /* Show only first 2 paragraphs on very small mobile to reduce scroll */
//           .hlc-ceo-react__message:nth-child(4){
//             display:none;
//           }
//           .hlc-ceo-react__signature{ margin-top:12px; padding-top:10px; }
//           .hlc-ceo-react__signature strong{ font-size:12px; }
//           .hlc-ceo-react__signature span{ font-size:11px; }

//           /* --- JOURNEY SECTION --- */
//           .hlc-journey-react{
//             padding:32px 0 40px;
//           }
//           .hlc-journey-react__head{ margin-bottom:28px; }
//           .hlc-journey-react__head h2{ font-size:20px; margin:6px 0 8px; }
//           .hlc-journey-react__head p{ font-size:12.5px; line-height:1.65; }
//           .hlc-journey-react__tag{ font-size:10px; }

//           .hlc-journey-react__timeline{
//             grid-template-columns:repeat(2,minmax(0,1fr)) !important;
//             gap:12px;
//           }
//           .hlc-journey-react__card{ padding-top:28px; }
//           .hlc-journey-react__year{
//             position:absolute !important;
//             font-size:18px;
//             top:0; left:0;
//           }
//           .hlc-journey-react__box{
//             padding:12px 10px;
//             min-height:120px;
//           }
//           .hlc-journey-react__box h3{
//             font-size:12px;
//             margin-bottom:4px;
//             line-height:1.3;
//           }
//           .hlc-journey-react__box p{
//             font-size:10.5px;
//             line-height:1.5;
//           }

//           /* --- CERT SECTION --- */
//           .hlc-cert{
//             padding:20px 0 24px;
//           }
//           .hlc-cert__head{
//             margin-bottom:18px;
//           }
//           .hlc-cert__head h2{
//             font-size:16px;
//             margin:4px 0;
//           }
//           .hlc-cert__head p{
//             font-size:11.5px;
//             line-height:1.5;
//           }
//           .cert-tag{
//             font-size:9px;
//           }
//           .cert-card{
//             min-width:140px;
//             max-width:140px;
//             padding:10px;
//             display:flex;
//             flex-direction:column;
//             align-items:center;
//             box-sizing:border-box;
//           }
//           .cert-img{
//             height:45px;
//             margin-bottom:6px;
//           }
//           .cert-card h3{
//             font-size:11px;
//             margin-bottom:3px;
//           }
//           .cert-card p{
//             font-size:10px;
//             line-height:1.4;
//           }
//           .hlc-cert-track{ animation-duration:22s; gap:12px; }
//         }

//         /* Very small phones */
//         @media (max-width:400px){
//           .hlc-about-react__content h1{ font-size:20px; }
//           .hlc-about-react__btn-primary,
//           .hlc-about-react__btn-outline{ font-size:10px; padding:9px 8px; }
//           .hlc-ceo-react__content h2{ font-size:14px; }
//           .hlc-ceo-react__message{ font-size:11.5px; }
//           .hlc-journey-react__box h3{ font-size:12px; }
//           .hlc-journey-react__box p{ font-size:11px; }
//           .hlc-journey-react__year{ font-size:16px; }
//           .cert-card{ min-width:160px; max-width:160px; }
//         }

//         @media (max-width:768px){
//           .hlc-cert-track{
//             animation-duration:18s;
//             gap:10px;
//           }
//         }
//       `}</style>
//       <div className="about-page-root">

//         {/* SECTION 1 — HERO */}
//         <section className="hlc-about-react" id="about-hlc">
//           <div className="hlc-about-react__inner">
//             <div className="hlc-about-react__grid">
//               <div className="hlc-about-react__content about-animate-up" ref={addToRefs}>
//                 <p className="hlc-about-react__eyebrow">About HLC</p>
//                 <h1>Built on Legacy. Driven by Innovation.</h1>
//                 <p className="hlc-about-react__lead">
//                   With a long-standing legacy in the lighting industry, HLC (High Lite Concern) delivers
//                   innovative, efficient and design-forward LED solutions for indoor and outdoor
//                   applications — built to elevate spaces with reliability, performance and style.
//                 </p>
//                 <div className="hlc-about-react__highlights">
//                   <div className="hlc-about-react__highlight">
//                     <span className="hlc-about-react__dot"></span>
//                     <div className="hlc-about-react__highlight-text">
//                       <strong>50+ Years</strong>
//                       <span>legacy in lighting</span>
//                     </div>
//                   </div>
//                   <div className="hlc-about-react__highlight">
//                     <span className="hlc-about-react__dot"></span>
//                     <div className="hlc-about-react__highlight-text">
//                       <strong>Est. 1970</strong>
//                       <span>family-led vision</span>
//                     </div>
//                   </div>
//                   <div className="hlc-about-react__highlight">
//                     <span className="hlc-about-react__dot"></span>
//                     <div className="hlc-about-react__highlight-text">
//                       <strong>Since 2018</strong>
//                       <span>modern manufacturing</span>
//                     </div>
//                   </div>
//                   <div className="hlc-about-react__highlight">
//                     <span className="hlc-about-react__dot"></span>
//                     <div className="hlc-about-react__highlight-text">
//                       <strong>ISO 9001</strong>
//                       <span>quality commitment</span>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="hlc-about-react__cta">
//                   <a href="#hlc-ceo" className="hlc-about-react__btn-primary">From Our CEO</a>
//                   <a href="#hlc-journey" className="hlc-about-react__btn-outline">Our Journey</a>
//                 </div>
//                 <p className="hlc-about-react__note">
//                   Trusted by partners, distributors and dealers — powering homes, workplaces
//                   and projects with dependable LED solutions across Pakistan.
//                 </p>
//               </div>

//               <div className="hlc-about-react__visual about-animate-up about-delay-1" ref={addToRefs}>
//                 <div className="hlc-about-react__visual-box">
//                   <div className="hlc-about-react__visual-top">
//                     <p className="hlc-about-react__visual-eyebrow">Why HLC</p>
//                     <h2>Design. Performance. Trust.</h2>
//                   </div>
//                   <p className="hlc-about-react__visual-desc">
//                     For decades, HLC has remained committed to quality engineering, modern aesthetics
//                     and energy-efficient innovation for residential, commercial and industrial lighting projects.
//                   </p>
//                   <ul className="hlc-about-react__visual-list">
//                     <li>Advanced LED Technology</li>
//                     <li>Nationwide Dealer Network</li>
//                     <li>Residential, Commercial &amp; Industrial Solutions</li>
//                   </ul>
//                   <div className="hlc-about-react__stats">
//                     <div className="hlc-about-react__mini-stat">
//                       <strong>1970</strong>
//                       <span>Founded</span>
//                     </div>
//                     <div className="hlc-about-react__mini-stat">
//                       <strong>50+</strong>
//                       <span>Years</span>
//                     </div>
//                     <div className="hlc-about-react__mini-stat">
//                       <strong>ISO</strong>
//                       <span>Focused</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* SECTION 2 — CEO */}
//         <section className="hlc-ceo-react" id="hlc-ceo">
//           <div className="hlc-ceo-react__inner">
//             <div className="hlc-ceo-react__grid">
//               <div className="hlc-ceo-react__image about-animate-up" ref={addToRefs}>
//                 <div className="hlc-ceo-react__image-box">
//                   <img src={ceo} alt="CEO - HLC Lighting" />
//                 </div>
//               </div>
//               <div className="hlc-ceo-react__content about-animate-up about-delay-1" ref={addToRefs}>
//                 <span className="hlc-ceo-react__eyebrow">From Our CEO</span>
//                 <h2>Leading with Integrity, Innovation &amp; Trust</h2>
//                 <p className="hlc-ceo-react__message">
//                   Since our inception, HLC has been driven by a simple yet powerful belief: lighting
//                   is not just about illumination — it is about enhancing lives, empowering businesses,
//                   and shaping environments.
//                 </p>
//                 <p className="hlc-ceo-react__message">
//                   Over the decades, we have continuously evolved by embracing innovation, investing in
//                   modern manufacturing, and maintaining uncompromising quality standards. Our commitment
//                   is to deliver reliable, energy-efficient and aesthetically refined LED solutions that
//                   our partners can trust.
//                 </p>
//                 <p className="hlc-ceo-react__message">
//                   As we look toward the future, HLC remains dedicated to sustainability, customer
//                   satisfaction, and long-term partnerships — lighting the way forward with responsibility
//                   and excellence.
//                 </p>
//                 <div className="hlc-ceo-react__signature">
//                   <strong>— Chief Executive Officer</strong>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* SECTION 3 — JOURNEY */}
//         <section className="hlc-journey-react" id="hlc-journey">
//           <div className="hlc-journey-react__inner">
//             <div className="hlc-journey-react__head about-reveal" ref={addToRefs}>
//               <span className="hlc-journey-react__tag">OUR JOURNEY</span>
//               <h2>Decades of Excellence in Lighting Innovation</h2>
//               <p>
//                 From a legacy-driven foundation to a future-focused LED brand, HLC's journey
//                 reflects consistency, trust and continuous innovation.
//               </p>
//             </div>
//             <div className="hlc-journey-react__timeline">
//               <div className="hlc-journey-react__card about-reveal" ref={addToRefs}>
//                 <div className="hlc-journey-react__year">1970</div>
//                 <div className="hlc-journey-react__box">
//                   <h3>Foundation &amp; Trust</h3>
//                   <p>
//                     HLC began its journey with a clear vision — delivering dependable lighting solutions
//                     built on quality, craftsmanship and long-term customer relationships.
//                   </p>
//                 </div>
//               </div>
//               <div className="hlc-journey-react__card about-reveal about-delay-1" ref={addToRefs}>
//                 <div className="hlc-journey-react__year">2018</div>
//                 <div className="hlc-journey-react__box">
//                   <h3>Modern Expansion</h3>
//                   <p>
//                     The brand entered a new phase with upgraded manufacturing, advanced LED technologies
//                     and internationally aligned quality processes.
//                   </p>
//                 </div>
//               </div>
//               <div className="hlc-journey-react__card about-reveal about-delay-2" ref={addToRefs}>
//                 <div className="hlc-journey-react__year hlc-journey-react__year--highlight">Today</div>
//                 <div className="hlc-journey-react__box">
//                   <h3>Innovation-Led Growth</h3>
//                   <p>
//                     HLC stands as a trusted national LED lighting brand delivering energy-efficient
//                     solutions for residential, commercial, industrial and outdoor applications.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* SECTION 4 — CERTIFICATIONS */}
//         <section className="hlc-cert" id="hlc-cert">
//           <div className="hlc-cert__inner">
//             <div className="hlc-cert__head about-reveal" ref={addToRefs}>
//               <span className="cert-tag">WALL OF CERTIFICATION</span>
//               <h2>Recognized for Quality, Innovation &amp; Trust</h2>
//               <p>
//                 Our certifications and recognitions reflect our commitment to quality, global standards,
//                 and trusted performance in the lighting industry.
//               </p>
//             </div>
//             {certificates.length === 0 ? (
//               <div className="hlc-cert-empty">
//                 <p style={{ textAlign: "center", color: "rgba(255,255,255,.7)" }}>Loading certifications…</p>
//               </div>
//             ) : (
//               <div className="hlc-cert-slider">
//                 <div className="hlc-cert-track">
//                   {sliderCards.map((cert, index) => (
//                     <div className="cert-card" key={`${cert.id}-${index}`}>
//                       <div className="cert-img">
//                         {cert.image ? (
//                           <img src={cert.image} alt={cert.title} />
//                         ) : (
//                           <div className="cert-img-placeholder">
//                             <span style={{ fontSize: 28 }}>🏆</span>
//                           </div>
//                         )}
//                       </div>
//                       <h3>{cert.title}</h3>
//                       <p>{cert.desc}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//         </section>

//       </div>
//       <HlcFooter />
//     </>
//   );
// }


import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import HlcFooter from "../components/HlcFooter";
import ceo from "../assets/ceo.jpeg";
import { API_BASE_URL, getImageUrl } from "../config/apiConfig";

export default function AboutUsPage() {
  const animatedRefs = useRef([]);
  const [certificates, setCertificates] = useState([]);

  /* ================= FETCH CERTIFICATES FROM adminhlc-api (MySQL) =================
     Step 1 of the Firebase->PHP migration. Public, unauthenticated endpoint --
     mirrors api/certificates/list.php minus require_auth(). */
  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE_URL}/api/public/certificates/list.php`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        const mapped = Array.isArray(data)
          ? data.map((cert) => ({ ...cert, image: getImageUrl(cert.image) }))
          : [];
        setCertificates(mapped);
      })
      .catch((err) => {
        console.error("Failed to fetch certificates:", err);
        if (!cancelled) setCertificates([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const elements = animatedRefs.current.filter(Boolean);
    if (!elements.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const addToRefs = (el) => {
    if (el && !animatedRefs.current.includes(el)) {
      animatedRefs.current.push(el);
    }
  };

  // Duplicate the list so the infinite scroll loop is seamless
  const sliderCards = [...certificates, ...certificates];

  return (
    <>
      <Navbar />
  <style>{`
        :root{
          --about-magenta:#9b1f6c;
          --about-plum:#542757;
          --about-navy:#35335b;
          --about-text:#141320;
          --about-muted:#6b677a;
          --about-line:#eceaf1;
          --about-bg:#f7f7fb;
          --about-white:#ffffff;
          --about-light:rgba(255,255,255,.88);
          --about-soft:rgba(255,255,255,.74);
          --about-line-white:rgba(255,255,255,.14);
        }

        .about-page-root{
          width:100%;
          overflow:hidden;
          font-family:"Open Sans",system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
          background:#fff;
          margin-top:40px;
        }

        /* SHARED ANIMATION */
        .about-animate-up,
        .about-reveal{
          opacity:0;
          transform:translateY(28px);
          transition:opacity .7s ease,transform .7s ease;
        }
        .about-animate-up.show,
        .about-reveal.show{ opacity:1; transform:none; }
        .about-delay-1{ transition-delay:.12s; }
        .about-delay-2{ transition-delay:.24s; }

        /* =========================================================
           SECTION 1 — HERO
        ========================================================= */
        .hlc-about-react{
          background:linear-gradient(180deg,#ffffff 0%,#f7f7fb 100%);
          padding:clamp(36px,5vw,80px) 0;
          overflow:hidden;
        }
        .hlc-about-react__inner{
          width:min(1200px,92vw);
          margin:auto;
        }
        .hlc-about-react__grid{
          display:grid;
          grid-template-columns:minmax(0,1.08fr) minmax(300px,.92fr);
          gap:clamp(20px,3vw,50px);
          align-items:center;
        }
        .hlc-about-react__eyebrow{
          margin:0 0 6px;
          font-size:11px;
          font-weight:700;
          letter-spacing:.18em;
          text-transform:uppercase;
          color:var(--about-magenta);
          margin-top:20px
        }
        .hlc-about-react__content h1{
          font-size:clamp(26px,3.8vw,52px);
          line-height:1.06;
          letter-spacing:-.03em;
          margin:0 0 14px;
          color:var(--about-text);
          font-weight:600;
          max-width:13ch;
        }
        .hlc-about-react__lead{
          font-size:15px;
          line-height:1.75;
          color:#4d4b60;
          margin:0 0 22px;
          max-width:660px;
        }
        .hlc-about-react__highlights{
          display:grid;
          grid-template-columns:repeat(2,minmax(0,1fr));
          gap:10px 12px;
          margin-bottom:22px;
        }
        .hlc-about-react__highlight{
          display:flex;
          align-items:flex-start;
          gap:10px;
          padding:14px;
          background:#fff;
          border:1px solid var(--about-line);
          box-shadow:0 8px 20px rgba(20,19,32,.05);
          transition:.3s ease;
        }
        .hlc-about-react__highlight:hover{
          transform:translateY(-3px);
          box-shadow:0 14px 32px rgba(155,31,108,.12);
          border-color:rgba(155,31,108,.3);
        }
        .hlc-about-react__dot{
          width:9px;
          height:9px;
          margin-top:5px;
          flex:0 0 9px;
          background:linear-gradient(135deg,var(--about-magenta),var(--about-plum));
        }
        .hlc-about-react__highlight-text{ display:flex; flex-direction:column; gap:2px; min-width:0; }
        .hlc-about-react__highlight-text strong{ font-size:13px; line-height:1.3; color:var(--about-navy); }
        .hlc-about-react__highlight-text span{ font-size:12px; line-height:1.45; color:var(--about-muted); }
        .hlc-about-react__cta{
          display:flex;
          gap:12px;
          flex-wrap:wrap;
          margin-bottom:14px;
        }
        .hlc-about-react__btn-primary,
        .hlc-about-react__btn-outline{
          min-height:42px;
          padding:11px 18px;
          font-size:12px;
          font-weight:800;
          letter-spacing:.08em;
          text-transform:uppercase;
          text-decoration:none;
          border-radius:0;
          transition:.26s ease;
          display:inline-flex;
          align-items:center;
          justify-content:center;
        }
        .hlc-about-react__btn-primary{
          background:var(--about-magenta);
          color:#fff;
          border:1px solid var(--about-magenta);
          box-shadow:0 8px 20px rgba(155,31,108,.14);
        }
        .hlc-about-react__btn-primary:hover{ background:var(--about-plum); border-color:var(--about-plum); transform:translateY(-2px); }
        .hlc-about-react__btn-outline{
          background:#fff;
          color:var(--about-magenta);
          border:1px solid rgba(155,31,108,.4);
        }
        .hlc-about-react__btn-outline:hover{ background:rgba(155,31,108,.07); transform:translateY(-2px); }
        .hlc-about-react__note{
          font-size:13px;
          line-height:1.65;
          color:var(--about-muted);
          max-width:540px;
          margin:0;
        }
        .hlc-about-react__visual{ display:flex; justify-content:flex-end; }
        .hlc-about-react__visual-box{
          position:relative;
          width:min(100%,440px);
          background:linear-gradient(135deg,#fff 0%,#f7f7fb 100%);
          border:1px solid var(--about-line);
          padding:26px 24px;
          box-shadow:0 20px 40px rgba(20,19,32,.09);
          transition:.35s ease;
          overflow:hidden;
        }
        .hlc-about-react__visual-box::before{
          content:"";
          position:absolute;
          inset:0 auto 0 0;
          width:4px;
          background:linear-gradient(180deg,var(--about-magenta),var(--about-plum),var(--about-navy));
        }
        .hlc-about-react__visual-box:hover{ transform:translateY(-5px); box-shadow:0 28px 54px rgba(20,19,32,.14); }
        .hlc-about-react__visual-eyebrow{
          margin:0 0 5px;
          font-size:11px;
          font-weight:700;
          letter-spacing:.16em;
          text-transform:uppercase;
          color:var(--about-magenta);
        }
        .hlc-about-react__visual-box h2{
          margin:0 0 10px;
          font-size:clamp(20px,2vw,28px);
          line-height:1.15;
          color:var(--about-navy);
          font-weight:800;
        }
        .hlc-about-react__visual-desc{
          font-size:13px;
          line-height:1.7;
          color:#555;
          margin:0 0 14px;
        }
        .hlc-about-react__visual-list{
          list-style:none;
          padding:0;
          margin:0 0 18px;
          display:grid;
          gap:8px;
        }
        .hlc-about-react__visual-list li{
          position:relative;
          padding-left:20px;
          font-size:13px;
          line-height:1.55;
          color:#444;
        }
        .hlc-about-react__visual-list li::before{
          content:"";
          position:absolute;
          left:0;
          top:7px;
          width:9px;
          height:9px;
          background:linear-gradient(135deg,var(--about-magenta),var(--about-plum));
        }
        .hlc-about-react__stats{
          display:grid;
          grid-template-columns:repeat(3,minmax(0,1fr));
          gap:8px;
          margin-top:4px;
        }
        .hlc-about-react__mini-stat{
          background:#fff;
          border:1px solid var(--about-line);
          padding:12px 8px;
          text-align:center;
          box-shadow:0 6px 16px rgba(20,19,32,.04);
        }
        .hlc-about-react__mini-stat strong{
          display:block;
          font-size:18px;
          line-height:1.1;
          color:var(--about-navy);
          font-weight:800;
        }
        .hlc-about-react__mini-stat span{
          display:block;
          margin-top:3px;
          font-size:11px;
          line-height:1.35;
          color:var(--about-muted);
        }

        /* =========================================================
           SECTION 2 — CEO
        ========================================================= */
        .hlc-ceo-react{
          position:relative;
          background:
            radial-gradient(circle at top left,rgba(155,31,108,.22),transparent 32%),
            radial-gradient(circle at bottom right,rgba(84,39,87,.26),transparent 34%),
            linear-gradient(135deg,#9b1f6c 0%,#542757 45%,#35335b 100%);
          padding:clamp(40px,6vw,88px) 0;
          overflow:hidden;
          color:#fff;
        }
        .hlc-ceo-react__inner{
          width:min(1200px,92vw);
          margin:auto;
        }
        .hlc-ceo-react__grid{
          display:grid;
          grid-template-columns:minmax(260px,.85fr) minmax(0,1.15fr);
          gap:clamp(20px,3.5vw,50px);
          align-items:center;
        }
        .hlc-ceo-react__image-box{
          position:relative;
          background:rgba(255,255,255,.06);
          border:1px solid rgba(255,255,255,.14);
          padding:14px;
          box-shadow:0 20px 48px rgba(0,0,0,.22);
          transition:.35s ease;
          overflow:hidden;
        }
        .hlc-ceo-react__image-box::before{
          content:"";
          position:absolute;
          inset:0 auto 0 0;
          width:4px;
          background:linear-gradient(180deg,var(--about-magenta),var(--about-plum),var(--about-navy));
        }
        .hlc-ceo-react__image-box:hover{ transform:translateY(-6px); box-shadow:0 30px 64px rgba(0,0,0,.28); }
        .hlc-ceo-react__image-box img{
          width:100%;
          display:block;
          object-fit:cover;
          aspect-ratio:5/6;
        }
        .hlc-ceo-react__eyebrow{
          display:inline-block;
          font-size:11px;
          letter-spacing:.18em;
          text-transform:uppercase;
          color:#ffd6ef;
          margin-bottom:8px;
          font-weight:700;
        }
        .hlc-ceo-react__content h2{
          font-size:clamp(24px,3vw,42px);
          line-height:1.1;
          margin:0 0 16px;
          color:#fff;
          font-weight:800;
          letter-spacing:-.02em;
        }
        .hlc-ceo-react__message{
          font-size:14px;
          line-height:1.78;
          color:var(--about-light);
          margin:0 0 12px;
        }
        .hlc-ceo-react__signature{
          margin-top:20px;
          padding-top:14px;
          border-top:1px solid var(--about-line-white);
        }
        .hlc-ceo-react__signature strong{ display:block; font-size:14px; color:#fff; font-weight:700; }
        .hlc-ceo-react__signature span{ display:block; margin-top:3px; font-size:12px; color:var(--about-soft); }

        /* =========================================================
           SECTION 3 — JOURNEY
        ========================================================= */
        .hlc-journey-react{
          padding:clamp(56px,8vw,100px) 0;
          background:
            radial-gradient(1000px 500px at 90% -10%,rgba(155,31,108,.07),transparent 60%),
            linear-gradient(180deg,#f7f8fc 0%,#ffffff 100%);
        }
        .hlc-journey-react__inner{
          width:min(1200px,92vw);
          margin:auto;
        }
        .hlc-journey-react__head{
          max-width:720px;
          margin-bottom:48px;
        }
        .hlc-journey-react__tag{
          display:inline-block;
          font-size:11px;
          font-weight:800;
          letter-spacing:.18em;
          color:#9b1f6c;
        }
        .hlc-journey-react__head h2{
          font-size:clamp(26px,3.2vw,40px);
          margin:8px 0 12px;
          color:#1c1b29;
          line-height:1.15;
        }
        .hlc-journey-react__head p{
          font-size:14px;
          line-height:1.72;
          color:#55536a;
          margin:0;
        }
        .hlc-journey-react__timeline{
          display:grid;
          grid-template-columns:repeat(3,1fr);
          gap:28px;
        }
        .hlc-journey-react__card{ position:relative; padding-top:36px; }
        .hlc-journey-react__year{
          position:absolute;
          top:0; left:0;
          font-size:26px;
          font-weight:900;
          color:#9b1f6c;
        }
        .hlc-journey-react__year--highlight{ color:#35335b; }
        .hlc-journey-react__box{
          background:#fff;
          border:1px solid #eceaf1;
          padding:24px 26px;
          box-shadow:0 14px 36px rgba(20,19,32,.08);
          transition:.32s ease;
        }
        .hlc-journey-react__box:hover{ transform:translateY(-6px); box-shadow:0 24px 58px rgba(20,19,32,.15); }
        .hlc-journey-react__box h3{ font-size:20px; margin:0 0 8px; color:#35335b; }
        .hlc-journey-react__box p{ margin:0; font-size:13.5px; line-height:1.72; color:#4d4b60; }

        /* =========================================================
           SECTION 4 — CERTIFICATIONS
        ========================================================= */
        .hlc-cert{
          padding:clamp(40px,7vw,70px) 0;
          background:
            radial-gradient(circle at 20% 0%,rgba(155,31,108,.12),transparent 40%),
            linear-gradient(135deg,#9b1f6c 0%,#542757 45%,#35335b 100%);
          color:#fff;
          overflow:hidden;
          font-family:"Open Sans",system-ui;
        }
        .hlc-cert__inner{ width:min(1200px,92vw); margin:auto; }
        .hlc-cert__head{ text-align:center; max-width:720px; margin:0 auto 40px; }
        .cert-tag{ font-size:11px; letter-spacing:.10em; font-weight:800; color:#ffd6ef; }
        .hlc-cert__head h2{ font-size:clamp(18px,3.2vw,38px); margin:8px 0; }
        .hlc-cert__head p{ font-size:14px; line-height:1.68; color:rgba(255,255,255,.85); }
        .hlc-cert-slider{ overflow:hidden; }
        .hlc-cert-track{
          display:flex;
          gap:16px;
          width:max-content;
          animation:scrollCert 35s linear infinite;
          align-items:stretch;
        }
        .cert-card{
          min-width:230px;
          max-width:230px;
          background:rgba(255,255,255,.08);
          border:1px solid rgba(255,255,255,.18);
          backdrop-filter:blur(6px);
          padding:16px;
          text-align:center;
          transition:.3s;
          display:flex;
          flex-direction:column;
          align-items:center;
          box-sizing:border-box;
        }
        .cert-card:hover{ transform:translateY(-5px); background:rgba(255,255,255,.12); }
        .cert-img{
          height:80px;
          width:100%;
          display:flex;
          align-items:center;
          justify-content:center;
          margin-bottom:10px;
          flex-shrink:0;
        }
        .cert-img img{ max-width:100%; max-height:100%; object-fit:contain; }
        .cert-card h3{
          font-size:14px;
          margin-bottom:5px;
          word-break:break-word;
          overflow-wrap:break-word;
          line-height:1.4;
          width:100%;
        }
        .cert-card p{
          font-size:12px;
          line-height:1.5;
          color:rgba(255,255,255,.75);
          margin:0;
          word-break:break-word;
          overflow-wrap:break-word;
          width:100%;
        }
        @keyframes scrollCert{
          0%{ transform:translateX(0); }
          100%{ transform:translateX(-50%); }
        }
        .hlc-cert-slider:hover .hlc-cert-track{ animation-play-state:paused; }

        /* =========================================================
           TABLET
        ========================================================= */
        @media (max-width:1024px){
          .hlc-about-react__grid{ grid-template-columns:1fr; gap:24px; }
          .hlc-about-react__content h1{ max-width:none; }
          .hlc-about-react__visual{ justify-content:flex-start; }
          .hlc-about-react__visual-box{ width:100%; max-width:none; }
          .hlc-ceo-react__grid{ gap:24px; }
        }
        @media (max-width:992px){
          .hlc-journey-react__timeline{ grid-template-columns:1fr; gap:36px; }
          .hlc-journey-react__year{ position:static; margin-bottom:8px; }
        }
        @media (max-width:900px){
          .hlc-ceo-react__grid{ grid-template-columns:1fr; }
          .hlc-ceo-react__image{ order:1; }
          .hlc-ceo-react__content{ order:2; }
        }

        /* =========================================================
           MOBILE — COMPACT PROFESSIONAL LAYOUT
        ========================================================= */
        @media (max-width:767px){

          /* --- HERO SECTION --- */
          .hlc-about-react{
            padding:28px 0 36px;
          }
          .hlc-about-react__inner,
          .hlc-ceo-react__inner,
          .hlc-journey-react__inner{
            width:min(1200px,93vw);
          }
          .hlc-about-react__eyebrow{ font-size:10px; }
          .hlc-about-react__content h1{
            font-size:22px;
            line-height:1.1;
            margin-bottom:10px;
            max-width:none;
          }
          .hlc-about-react__lead{
            font-size:13px;
            line-height:1.65;
            margin-bottom:16px;
          }

          /* 2-col highlights on mobile */
          .hlc-about-react__highlights{
            grid-template-columns:repeat(2,minmax(0,1fr));
            gap:8px;
            margin-bottom:16px;
          }
          .hlc-about-react__highlight{ padding:11px 10px; gap:8px; }
          .hlc-about-react__dot{ width:8px; height:8px; flex:0 0 8px; margin-top:4px; }
          .hlc-about-react__highlight-text strong{ font-size:12px; }
          .hlc-about-react__highlight-text span{ font-size:11px; }

          /* CTAs in a row */
          .hlc-about-react__cta{
            flex-direction:row;
            gap:8px;
            margin-bottom:12px;
          }
          .hlc-about-react__btn-primary,
          .hlc-about-react__btn-outline{
            flex:1;
            min-height:38px;
            padding:10px 10px;
            font-size:11px;
          }
          .hlc-about-react__note{ font-size:12px; line-height:1.6; }

          /* Visual box compact */
          .hlc-about-react__visual-box{ padding:16px 14px; }
          .hlc-about-react__visual-box h2{ font-size:18px; margin-bottom:8px; }
          .hlc-about-react__visual-desc{ font-size:12px; line-height:1.6; margin-bottom:10px; }
          .hlc-about-react__visual-list{ gap:6px; margin-bottom:12px; }
          .hlc-about-react__visual-list li{ font-size:12px; padding-left:16px; }
          .hlc-about-react__visual-list li::before{ width:8px; height:8px; top:6px; }

          /* Stats always 3-col row on mobile */
          .hlc-about-react__stats{
            grid-template-columns:repeat(3,minmax(0,1fr));
            gap:6px;
          }
          .hlc-about-react__mini-stat{ padding:10px 6px; }
          .hlc-about-react__mini-stat strong{ font-size:15px; }
          .hlc-about-react__mini-stat span{ font-size:10px; }

          /* --- CEO SECTION --- */
          .hlc-ceo-react{
            padding:28px 0 36px;
          }

          /* Side-by-side on mobile: small image left, text right */
          .hlc-ceo-react__grid{
            grid-template-columns:minmax(0,1fr) minmax(0,1.6fr) !important;
            gap:14px;
            align-items:start;
          }
          .hlc-ceo-react__image{ order:1 !important; }
          .hlc-ceo-react__content{ order:2 !important; }

          .hlc-ceo-react__image-box{
            padding:8px;
          }
          /* Compact portrait on mobile */
          .hlc-ceo-react__image-box img{
            aspect-ratio:3/4;
            width:100%;
          }
          .hlc-ceo-react__eyebrow{ font-size:10px; margin-bottom:6px; }
          .hlc-ceo-react__content h2{
            font-size:16px;
            margin-bottom:10px;
            line-height:1.2;
            letter-spacing:-.01em;
          }
          .hlc-ceo-react__message{
            font-size:12px;
            line-height:1.65;
            margin-bottom:9px;
          }
          /* Show only first 2 paragraphs on very small mobile to reduce scroll */
          .hlc-ceo-react__message:nth-child(4){
            display:none;
          }
          .hlc-ceo-react__signature{ margin-top:12px; padding-top:10px; }
          .hlc-ceo-react__signature strong{ font-size:12px; }
          .hlc-ceo-react__signature span{ font-size:11px; }

          /* --- JOURNEY SECTION --- */
          .hlc-journey-react{
            padding:32px 0 40px;
          }
          .hlc-journey-react__head{ margin-bottom:28px; }
          .hlc-journey-react__head h2{ font-size:20px; margin:6px 0 8px; }
          .hlc-journey-react__head p{ font-size:12.5px; line-height:1.65; }
          .hlc-journey-react__tag{ font-size:10px; }

          .hlc-journey-react__timeline{
            grid-template-columns:repeat(2,minmax(0,1fr)) !important;
            gap:12px;
          }
          .hlc-journey-react__card{ padding-top:28px; }
          .hlc-journey-react__year{
            position:absolute !important;
            font-size:18px;
            top:0; left:0;
          }
          .hlc-journey-react__box{
            padding:12px 10px;
            min-height:120px;
          }
          .hlc-journey-react__box h3{
            font-size:12px;
            margin-bottom:4px;
            line-height:1.3;
          }
          .hlc-journey-react__box p{
            font-size:10.5px;
            line-height:1.5;
          }

          /* --- CERT SECTION --- */
          .hlc-cert{
            padding:20px 0 24px;
          }
          .hlc-cert__head{
            margin-bottom:18px;
          }
          .hlc-cert__head h2{
            font-size:16px;
            margin:4px 0;
          }
          .hlc-cert__head p{
            font-size:11.5px;
            line-height:1.5;
          }
          .cert-tag{
            font-size:9px;
          }
          .cert-card{
            min-width:140px;
            max-width:140px;
            padding:10px;
            display:flex;
            flex-direction:column;
            align-items:center;
            box-sizing:border-box;
          }
          .cert-img{
            height:45px;
            margin-bottom:6px;
          }
          .cert-card h3{
            font-size:11px;
            margin-bottom:3px;
          }
          .cert-card p{
            font-size:10px;
            line-height:1.4;
          }
          .hlc-cert-track{ animation-duration:22s; gap:12px; }
        }

        /* Very small phones */
        @media (max-width:400px){
          .hlc-about-react__content h1{ font-size:20px; }
          .hlc-about-react__btn-primary,
          .hlc-about-react__btn-outline{ font-size:10px; padding:9px 8px; }
          .hlc-ceo-react__content h2{ font-size:14px; }
          .hlc-ceo-react__message{ font-size:11.5px; }
          .hlc-journey-react__box h3{ font-size:12px; }
          .hlc-journey-react__box p{ font-size:11px; }
          .hlc-journey-react__year{ font-size:16px; }
          .cert-card{ min-width:160px; max-width:160px; }
        }

        @media (max-width:768px){
          .hlc-cert-track{
            animation-duration:18s;
            gap:10px;
          }
        }
      `}</style>
      <div className="about-page-root">

        {/* SECTION 1 — HERO */}
        <section className="hlc-about-react" id="about-hlc">
          <div className="hlc-about-react__inner">
            <div className="hlc-about-react__grid">
              <div className="hlc-about-react__content about-animate-up" ref={addToRefs}>
                <p className="hlc-about-react__eyebrow">About HLC</p>
                <h1>Built on Legacy. Driven by Innovation.</h1>
                <p className="hlc-about-react__lead">
                  With a long-standing legacy in the lighting industry, HLC (High Lite Concern) delivers
                  innovative, efficient and design-forward LED solutions for indoor and outdoor
                  applications — built to elevate spaces with reliability, performance and style.
                </p>
                <div className="hlc-about-react__highlights">
                  <div className="hlc-about-react__highlight">
                    <span className="hlc-about-react__dot"></span>
                    <div className="hlc-about-react__highlight-text">
                      <strong>50+ Years</strong>
                      <span>legacy in lighting</span>
                    </div>
                  </div>
                  <div className="hlc-about-react__highlight">
                    <span className="hlc-about-react__dot"></span>
                    <div className="hlc-about-react__highlight-text">
                      <strong>Est. 1970</strong>
                      <span>family-led vision</span>
                    </div>
                  </div>
                  <div className="hlc-about-react__highlight">
                    <span className="hlc-about-react__dot"></span>
                    <div className="hlc-about-react__highlight-text">
                      <strong>Since 2018</strong>
                      <span>modern manufacturing</span>
                    </div>
                  </div>
                  <div className="hlc-about-react__highlight">
                    <span className="hlc-about-react__dot"></span>
                    <div className="hlc-about-react__highlight-text">
                      <strong>ISO 9001</strong>
                      <span>quality commitment</span>
                    </div>
                  </div>
                </div>
                <div className="hlc-about-react__cta">
                  <a href="#hlc-ceo" className="hlc-about-react__btn-primary">From Our CEO</a>
                  <a href="#hlc-journey" className="hlc-about-react__btn-outline">Our Journey</a>
                </div>
                <p className="hlc-about-react__note">
                  Trusted by partners, distributors and dealers — powering homes, workplaces
                  and projects with dependable LED solutions across Pakistan.
                </p>
              </div>

              <div className="hlc-about-react__visual about-animate-up about-delay-1" ref={addToRefs}>
                <div className="hlc-about-react__visual-box">
                  <div className="hlc-about-react__visual-top">
                    <p className="hlc-about-react__visual-eyebrow">Why HLC</p>
                    <h2>Design. Performance. Trust.</h2>
                  </div>
                  <p className="hlc-about-react__visual-desc">
                    For decades, HLC has remained committed to quality engineering, modern aesthetics
                    and energy-efficient innovation for residential, commercial and industrial lighting projects.
                  </p>
                  <ul className="hlc-about-react__visual-list">
                    <li>Advanced LED Technology</li>
                    <li>Nationwide Dealer Network</li>
                    <li>Residential, Commercial &amp; Industrial Solutions</li>
                  </ul>
                  <div className="hlc-about-react__stats">
                    <div className="hlc-about-react__mini-stat">
                      <strong>1970</strong>
                      <span>Founded</span>
                    </div>
                    <div className="hlc-about-react__mini-stat">
                      <strong>50+</strong>
                      <span>Years</span>
                    </div>
                    <div className="hlc-about-react__mini-stat">
                      <strong>ISO</strong>
                      <span>Focused</span>
                    </div>
                  </div>
                  <Link to="/whyhlc" className="hlc-about-react__btn-outline" style={{ marginTop: 16, display: "inline-block" }}>
                    Why Choose HLC →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 2 — CEO */}
        <section className="hlc-ceo-react" id="hlc-ceo">
          <div className="hlc-ceo-react__inner">
            <div className="hlc-ceo-react__grid">
              <div className="hlc-ceo-react__image about-animate-up" ref={addToRefs}>
                <div className="hlc-ceo-react__image-box">
                  <img src={ceo} alt="CEO - HLC Lighting" />
                </div>
              </div>
              <div className="hlc-ceo-react__content about-animate-up about-delay-1" ref={addToRefs}>
                <span className="hlc-ceo-react__eyebrow">From Our CEO</span>
                <h2>Leading with Integrity, Innovation &amp; Trust</h2>
                <p className="hlc-ceo-react__message">
                  Since our inception, HLC has been driven by a simple yet powerful belief: lighting
                  is not just about illumination — it is about enhancing lives, empowering businesses,
                  and shaping environments.
                </p>
                <p className="hlc-ceo-react__message">
                  Over the decades, we have continuously evolved by embracing innovation, investing in
                  modern manufacturing, and maintaining uncompromising quality standards. Our commitment
                  is to deliver reliable, energy-efficient and aesthetically refined LED solutions that
                  our partners can trust.
                </p>
                <p className="hlc-ceo-react__message">
                  As we look toward the future, HLC remains dedicated to sustainability, customer
                  satisfaction, and long-term partnerships — lighting the way forward with responsibility
                  and excellence.
                </p>
                <div className="hlc-ceo-react__signature">
                  <strong>— Chief Executive Officer</strong>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 3 — JOURNEY */}
        <section className="hlc-journey-react" id="hlc-journey">
          <div className="hlc-journey-react__inner">
            <div className="hlc-journey-react__head about-reveal" ref={addToRefs}>
              <span className="hlc-journey-react__tag">OUR JOURNEY</span>
              <h2>Decades of Excellence in Lighting Innovation</h2>
              <p>
                From a legacy-driven foundation to a future-focused LED brand, HLC's journey
                reflects consistency, trust and continuous innovation.
              </p>
            </div>
            <div className="hlc-journey-react__timeline">
              <div className="hlc-journey-react__card about-reveal" ref={addToRefs}>
                <div className="hlc-journey-react__year">1970</div>
                <div className="hlc-journey-react__box">
                  <h3>Foundation &amp; Trust</h3>
                  <p>
                    HLC began its journey with a clear vision — delivering dependable lighting solutions
                    built on quality, craftsmanship and long-term customer relationships.
                  </p>
                </div>
              </div>
              <div className="hlc-journey-react__card about-reveal about-delay-1" ref={addToRefs}>
                <div className="hlc-journey-react__year">2018</div>
                <div className="hlc-journey-react__box">
                  <h3>Modern Expansion</h3>
                  <p>
                    The brand entered a new phase with upgraded manufacturing, advanced LED technologies
                    and internationally aligned quality processes.
                  </p>
                </div>
              </div>
              <div className="hlc-journey-react__card about-reveal about-delay-2" ref={addToRefs}>
                <div className="hlc-journey-react__year hlc-journey-react__year--highlight">Today</div>
                <div className="hlc-journey-react__box">
                  <h3>Innovation-Led Growth</h3>
                  <p>
                    HLC stands as a trusted national LED lighting brand delivering energy-efficient
                    solutions for residential, commercial, industrial and outdoor applications.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 4 — CERTIFICATIONS */}
        <section className="hlc-cert" id="hlc-cert">
          <div className="hlc-cert__inner">
            <div className="hlc-cert__head about-reveal" ref={addToRefs}>
              <span className="cert-tag">WALL OF CERTIFICATION</span>
              <h2>Recognized for Quality, Innovation &amp; Trust</h2>
              <p>
                Our certifications and recognitions reflect our commitment to quality, global standards,
                and trusted performance in the lighting industry.
              </p>
            </div>
            {certificates.length === 0 ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <p style={{ color: "rgba(255,255,255,.7)" }}>Loading certifications…</p>
              </div>
            ) : (
              <div className="hlc-cert-slider">
                <div className="hlc-cert-track">
                  {sliderCards.map((cert, index) => (
                    <div className="cert-card" key={`${cert.id}-${index}`}>
                      <div className="cert-img">
                        {cert.image ? (
                          <img src={cert.image} alt={cert.title} loading="lazy" />
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <span style={{ fontSize: 28 }}>🏆</span>
                          </div>
                        )}
                      </div>
                      <h3>{cert.title}</h3>
                      <p>{cert.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>

      </div>
      <HlcFooter />
    </>
  );
}